export const ENERGIZER_PROMPT_NAME = 'energizer';